import { Link, useSearchParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { checkBothPayments } from "../../services/client/payment/checkStatus";

const PaymentStatus = () => {
  const [searchParams] = useSearchParams();
  const success = searchParams.get("success");
  const status = searchParams.get("status");
  const trackId = searchParams.get("trackId");
  const isReady = success && status && trackId;

  const { data, error, isLoading } = useQuery({
    queryKey: ["check-payment-status", success, status, trackId],
    queryFn: () =>
      checkBothPayments({
        success,
        status,
        trackId,
      }),
    enabled: !!isReady,
  });

  if (isLoading) return <div>در حال بارگذاری...</div>;

  if (error)
    return (
      <div className="py-5 my-5 text-center">
        <img
          alt="icon"
          src={require("./../../assets/media/global/errorPay.png")}
          style={{ width: "100px", height: "100px", objectFit: "cover" }}
        />
        <p className="fw-bold mt-3">پرداخت شما با شکست مواجه شد</p>
      </div>
    );

  if (data?.data?.ref_number && status == "2") {
    return (
      <div className="py-5 my-5 text-center">
        <img
          alt="icon"
          src={require("./../../assets/media/global/sucess.png")}
          style={{ width: "100px", height: "100px", objectFit: "cover" }}
        />
        <p className="text-site fw-bold mt-3">شماره پیگیری : {data.data.ref_number}</p>
        <p className="fw-bold mt-3">پرداخت شما با موفقیت انجام شد.</p>
        <Link to={"/user/orders"} className="btn btn-primary">
          بازگشت به سایت
        </Link>
      </div>
    );
  }

  return (
    <div className="py-5 my-5 text-center">
      <img
        alt="icon"
        src={require("./../../assets/media/global/errorPay.png")}
        style={{ width: "100px", height: "100px", objectFit: "cover" }}
      />
      <p className="fw-bold mt-3">پرداخت شما با شکست مواجه شد</p>
    </div>
  );
};

export default PaymentStatus;

